import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';

@Component({
  selector: 'app-ana-scheda-rifiuti',
  templateUrl: './ana-scheda-rifiuti.component.html',
  styleUrls: ['./ana-scheda-rifiuti.component.css']
})
export class AnaSchedaRifiutiComponent   extends NicaMaster implements OnInit  {

  constructor(

    private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,
    public apiservice: Apiservice,
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }

  ngOnInit() {
    this.activateRoute.queryParams.subscribe(params => {
      this.params = params

      console.log("Parametri=", this.params);


      this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName



      this.setGlobalVariableFromParams(params);

      console.log("Parametri=",this)
    })
  }

  formItemsEventScheda(ev){

  }
}
